import moment from "moment";

/**
 * [parseJwt Returns the week number of the passed date. For instance, Input of 01/01/2022 returns 1 (First week) ]
 * @param  {String} input
 * @return {Number}
 */
export default function weekOfMonth(input) {
  const momentObj = moment.unix(input);
  const firstDayOfMonth = momentObj.clone().startOf("month");
  const firstDayOfWeek = firstDayOfMonth.clone().startOf("week");
  const offset = firstDayOfMonth.diff(firstDayOfWeek, "days");
  return Math.ceil((momentObj.date() + offset) / 7);
}
